var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 2.5C14.4938 2.5 18.2322 5.73313 19.0159 10C18.2322 14.2668 14.4938 17.5 10.0004 17.5C5.50693 17.5 1.76862 14.2668 0.984863 10C1.76862 5.73313 5.50693 2.5 10.0004 2.5ZM10.0004 15.8333C13.5301 15.8333 16.5504 13.3767 17.3149 10C16.5504 6.62336 13.5301 4.16667 10.0004 4.16667C6.47066 4.16667 3.45035 6.62336 2.68581 10C3.45035 13.3767 6.47066 15.8333 10.0004 15.8333ZM10.0004 13.75C7.92931 13.75 6.25038 12.0711 6.25038 10C6.25038 7.92893 7.92931 6.25 10.0004 6.25C12.0714 6.25 13.7504 7.92893 13.7504 10C13.7504 12.0711 12.0714 13.75 10.0004 13.75ZM10.0004 12.0833C11.151 12.0833 12.0837 11.1506 12.0837 10C12.0837 8.84942 11.151 7.91667 10.0004 7.91667C8.84983 7.91667 7.91705 8.84942 7.91705 10C7.91705 11.1506 8.84983 12.0833 10.0004 12.0833Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.31bf6abef421d5174efdc6606efa4abf.svg";
export { ForwardRef as ReactComponent };